import { render, staticRenderFns } from "./enComingSoon.vue?vue&type=template&id=b12f9d02&scoped=true&"
import script from "./enComingSoon.vue?vue&type=script&lang=js&"
export * from "./enComingSoon.vue?vue&type=script&lang=js&"
import style0 from "./enComingSoon.vue?vue&type=style&index=0&id=b12f9d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12f9d02",
  null
  
)

export default component.exports